import { render } from "./take.vue?vue&type=template&id=659b0de6&scoped=true"
import script from "./take.vue?vue&type=script&lang=js"
export * from "./take.vue?vue&type=script&lang=js"

import "./take.vue?vue&type=style&index=0&id=659b0de6&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yimeng-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-659b0de6"]])

export default __exports__